import React from "react";

const testimonials = [
  {
    text: "Outstanding quality and exceptional service! Their organic products are premium grade, and delivery is always on time. Highly recommended!",
    stars: 5,
    author: "Sarah Mitchell, London",
  },
  {
    text: "Nirmita International exceeded our expectations! Top-notch products, reliable partnership, and excellent customer support. A trusted supplier!",
    stars: 5,
    author: "Hiroshi Tanaka, Tokyo",
  },

  {
    text: "Premium products with perfect packaging! Their commitment to organic farming is impressive. A reliable partner for our business!",
    stars: 5,
    author: "Emma Wilson, Singapore",
  },
  {
    text: "Fantastic experience working with Nirmita! Fresh products, timely shipments, and amazing quality. Absolutely the best in the industry!",
    stars: 5,
    author: "Carlos Mendez, Brazil",
  },
];

const Testimonials = () => {
  return (
    <section className="py-12 bg-[#FFF3D6] overflow-hidden w-full">
      <div className="container mx-auto">
        <div className="relative mb-12">
         
          <div className="relative z-10">
            <h2 className="text-3xl font-bold text-center mb-2 text-[#8F5D3F]">TESTIMONIALS</h2>
            <p className="text-center text-gray-700 mb-4">GREAT WORDS FROM OUR CLIENTS</p>
          </div>
        </div>

        {/* Scrolling container */}
        <div className="relative overflow-hidden w-full">
          <div className="flex w-max testimonial-scroll space-x-8">
            {/* Repeat cards twice for infinite scroll effect */}
            {[...Array(2)].map((_, i) => (
              <React.Fragment key={i}>
                {testimonials.map((testimonial, index) => (
                  <div key={`${i}-${index}`} className="relative flex justify-center items-center w-[350px]">
                    {/* Top-left quote */}
                    <div className="absolute z-20 -top-0 -left-0 w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#8F5D3F] flex items-center justify-center shadow-md overflow-hidden">
                      <img src="/images/icons/quote-right.svg" alt="quote" className="w-6 h-6 md:w-7 md:h-7 object-contain" />
                    </div>

                    {/* Card */}
                    <div
                      className="relative h-60 px-6 pt-8 pb-8 z-10 flex flex-col items-center justify-center bg-contain bg-no-repeat bg-center"
                      style={{
                        backgroundImage: 'url("/images/speech-bubble.png")',
                        backgroundSize: '100% 100%'
                      }}
                    >
                        <div 
                        className="relative w-full px-4 py-3"
                        style={{
                          backgroundImage: 'url("/images/Vector.png")',
                          backgroundSize: '100% 100%',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}
                      >
                      {/* Stars */}
                      <div className="flex mb-3">
                        {[...Array(testimonial.stars)].map((_, starIndex) => (
                          <img
                            key={starIndex}
                            src="/images/icons/star.svg"
                            alt="Star"
                            className="w-5 h-5 md:w-6 md:h-6 mx-0.5"
                          />
                        ))}
                      </div>
                    
                        <p className="text-sm text-gray-800 text-center">"{testimonial.text}"</p>
                        <p className="text-sm font-semibold text-[#8F5D3F] mt-2 text-center">{testimonial.author}</p>
                      </div>
                    </div>

                    {/* Bottom-right quote */}
                    <div className="absolute z-20 -bottom-0 -right-0 w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#8F5D3F] flex items-center justify-center shadow-md overflow-hidden">
                      <img src="/images/icons/quote-left.svg" alt="quote" className="w-6 h-6 md:w-7 md:h-7 object-contain" />
                    </div>
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollTestimonials {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }

        .testimonial-scroll {
          animation: scrollTestimonials 30s linear infinite;
        }
      `}</style>
    </section>
  );
};

export default Testimonials;